import moment from 'moment';
import axios from 'src/axios';
class MetricsService {
    startTimeCollection: Map<string, DimensionInfo> = new Map<string, DimensionInfo>();
    setDimensionInfo(name: metricsType, dimension: moment.unitOfTime.Diff = 's') {
        const dimensionInfo: DimensionInfo = {
            startTime: moment(Date.now()),
            dimension,
        };
        this.startTimeCollection.set(name, dimensionInfo);
    }

    sendMetrics(name: metricsType, tagValue: string) {
        const dimensionInfo = this.startTimeCollection.get(name);
        if (dimensionInfo) {
            const { startTime, dimension } = dimensionInfo;
            const now = moment(new Date());
            const value = now.diff(startTime, dimension, true);
            const metricData: MetricData = {
                name,
                value,
                tagName: STATUS,
                tagValue,
            };
            this.startTimeCollection.delete(name);
            axios.post('metrics', metricData);
        }
    }
}

export default new MetricsService();

export interface MetricData {
    name: string,
    value: number,
    tagName: string,
    tagValue: string
}

export interface DimensionInfo {
    startTime: moment.Moment;
    dimension: moment.unitOfTime.Diff;
}

export const UPLOAD_PREVIEW = 'upload_preview_duration_s';
export const LOAD_WEBVIEW = 'load_webview_duration_s';
export const DISPLAY_DESIGN = 'display_design_duration_s';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
export const STATUS = 'status';
export const METRICS_NAME = DISPLAY_DESIGN || UPLOAD_PREVIEW || LOAD_WEBVIEW;

export type metricsType = typeof METRICS_NAME;
